import { useContext } from 'react'

import { DraftsStorage } from '../../../../context'

export function useDraftStorage() {
  return useContext(DraftsStorage)
}
